<!-- ✅ AUTHENTICATED LAYOUT - Only show when user is logged in -->
<div *ngIf="userLoggedIn && isInitialized && displayNavigation" class="app-layout">  
  <top-nav class="fixed-topnav" fxHide.gt-xs [Corp]="appctx.CurrentOrg" [LoggedInUser]="appctx.CurrentUser"></top-nav>
  <mat-sidenav-container>    
    <mat-sidenav #appDrawer mode="side" opened="false">
      <mat-nav-list>
        <menu-list-item *ngFor="let item of navItems | visibilityfilter : navVisibilityFilter; trackBy: trackByRoutingUrl" [item]="item">
        </menu-list-item>
      </mat-nav-list>
    </mat-sidenav>
    <div class="panel-primary">
      <router-outlet (activate)='onActivate($event)'
                     (deactivate)='onDeactivate($event)'
                     (attach)='onAttach($event)'
                     (detach)='onDetach($event)'></router-outlet>
    </div>
    <div fxFlex></div>
  </mat-sidenav-container>
</div>

<!-- ✅ LOADING STATE - Show ONLY during initial auth check (before login page) -->
<div *ngIf="!authCheckComplete && !userLoggedIn" class="loading-container">
  <div class="loading-spinner">
    <mat-spinner class="spinner" diameter="50"></mat-spinner>
    <p>Initializing application...</p>
  </div>
</div>

<!-- ✅ UNAUTHENTICATED LAYOUT - Show login/org-selector pages -->
<div *ngIf="authCheckComplete && !userLoggedIn" class="auth-layout">
  <router-outlet (activate)='onActivate($event)'
                 (deactivate)='onDeactivate($event)'>
  </router-outlet>
</div>

<!-- ✅ LOADING OVERLAY - Show during navigation menu load -->
<div class="overlay-progress" *ngIf="indLoading">
  <!--<mat-spinner class="spinner" diameter="50"></mat-spinner>-->
</div>


<!--<mat-sidenav-container class="sidenav-container" [class.dark-theme]="false">-->
<!-- Navigation sidebar -->
<!--<mat-sidenav #appDrawer
             class="sidenav"
             mode="side"
             [opened]="displayNavigation"
             *ngIf="isInitialized && displayNavigation">
  <menu-list-item [items]="navItems | visibilityfilter:navVisibilityFilter"></menu-list-item>
</mat-sidenav>

<mat-sidenav-content>-->
<!-- Top navigation -->
<!--<top-nav *ngIf="isInitialized && displayNavigation"
         [Corp]="appctx.CurrentOrg"
         [LoggedInUser]="appctx.CurrentUser">
</top-nav>-->
<!-- Main content -->
<!--<div class="container-fluid sidenav-content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>-->
<!-- Loading indicator -->
